import { Pipe, PipeTransform } from "@angular/core";
import { DecimalPipe } from "@angular/common";

@Pipe({
    name: "fractionDigits",
    standalone: false
})
export class FractionDigitsPipe implements PipeTransform {
	constructor(private numberPipe: DecimalPipe) {}

	transform(value: any, numberOfDigits: number): string {
		const transformFormat = `0.${numberOfDigits}-${numberOfDigits}`;

		const transformedValue = this.numberPipe.transform(
			value,
			transformFormat
		);
		return transformedValue.split(".")[1];
	}
}
